import { styled } from '@mui/material/styles';
import { motion } from 'motion/react';
import { Box } from '@mui/material';
import { SidePanelPlacement } from 'features/side-panels/types';
import { getPanelHeight } from 'features/side-panels/utils';
import { TabPanel } from 'components/Tabs';

const MotionBox = motion.create(Box);

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'open',
})<{ isMobile?: boolean; open?: boolean }>(({ theme, isMobile, open }) => ({
  ...(isMobile &&
    open && {
      position: 'fixed',
      inset: 0,
      zIndex: theme.zIndex.drawer,
    }),
}));

export const PanelWrapper = styled(MotionBox, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile?: boolean; placement: SidePanelPlacement }>(({ theme, isMobile, placement }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  height: getPanelHeight(placement, isMobile),
  width: '100%',
  maxWidth: theme.toolbarPanel.width,
  padding: '8px',
  paddingRight: 0,
  marginTop: theme.topBar.height,
  willChange: 'transform',
  ...(placement === 'left' && {
    marginLeft: theme.toolbar.width,
    left: 0,
  }),
  ...(placement === 'right' && {
    marginRight: theme.toolbar.width,
    right: 0,
    paddingRight: '8px',
    paddingLeft: 0,
  }),
  ...(isMobile && {
    width: '85%',
    margin: 0,
    zIndex: theme.zIndex.drawer,
  }),
}));

export const Panel = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  overflow: 'hidden',
}));

export const ScrollableContent = styled('div')({
  overflowY: 'auto',
  flex: 1,
});

export const SidePanelScrollRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
});

export const SidePanelRoot = styled('div')({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const SearchWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 3),
}));

export const AddButtonWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const ScrollableTabPanel = styled(TabPanel)({
  overflow: 'hidden',
  flex: 1,
  '> div': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
